import React from 'react';
import { fontFamilies } from '../../../helpers/fonts';
import { Header } from './Header';
import { declareWithDefaults } from '../../../helpers/typescript';

type MinimalisticHeaderProps = React.ComponentProps<typeof Header>;

const MinimalisticHeaderComponent: React.FC<MinimalisticHeaderProps> = props => {
  return <Header {...props} />;
};

const defaultProps = {
  color: 'black',
  fontConfig: {
    fontFamily: fontFamilies.bold,
    fontSize: '15px',
    textTransform: 'capitalize',
  },
};
export const HeaderMinimalistic = declareWithDefaults<MinimalisticHeaderProps, keyof typeof defaultProps>(
  MinimalisticHeaderComponent,
  defaultProps,
);
